import { useEffect, useMemo, useState } from 'react';
import { ProgramFilterTagDefinition } from '@/features/programs/model/types';

export function useFilteredArticles<T extends { tags?: string[] }>(
    articles?: T[],
    filterTags?: ProgramFilterTagDefinition[],
) {
    const [selectedFilter, setSelectedFilter] = useState<string | null>(null);

    const normalize = (s: string) => s.toLowerCase();

    const filteredArticles = useMemo(() => {
        if (!articles) return [];

        if (!selectedFilter) return articles;

        return articles.filter((a) =>
            a.tags?.some((t) => normalize(t) === normalize(selectedFilter)),
        );
    }, [articles, selectedFilter]);

    const availableTagDefinitions = useMemo(() => {
        if (!articles || !filterTags) return [];

        return filterTags.filter(({ Tag }) =>
            articles.some((a) =>
                a.tags?.some((t) => normalize(t) === normalize(Tag)),
            ),
        );
    }, [articles, filterTags]);

    useEffect(() => {
        if (
            selectedFilter &&
            !availableTagDefinitions.some(
                (x) => normalize(x.Tag) === normalize(selectedFilter),
            )
        ) {
            setSelectedFilter(null);
        }
    }, [selectedFilter, availableTagDefinitions]);

    return {
        selectedFilter,
        setSelectedFilter,
        filteredArticles,
        availableTagDefinitions,
    };
}
